import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import { Link } from "react-router-dom";

const ResidencePage = () => {
  const [residences, setResidences] = useState([]);
  const [filteredResidences, setFilteredResidences] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 37.7749, lng: -122.4194 }); // الموقع الافتراضي لسان فرانسيسكو
  const [mapZoom, setMapZoom] = useState(10); // التكبير الافتراضي

  // جلب الإقامات وبياناتها
  useEffect(() => {
    const fetchResidences = async () => {
      const residencesRef = collection(db, "residences");
      const querySnapshot = await getDocs(residencesRef);
      const residencesList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setResidences(residencesList);
      setFilteredResidences(residencesList); // عرض جميع الإقامات في البداية

      // استخراج البلدان والمدن من الإقامات
      const countriesList = [...new Set(residencesList.map((residence) => residence.country))];
      const citiesList = [...new Set(residencesList.map((residence) => residence.city))];
      setCountries(countriesList);
      setCities(citiesList);
    };

    fetchResidences();
  }, []);

  // تصفية الإقامات بناءً على البحث والفلاتر
  useEffect(() => {
    const filtered = residences.filter((residence) => {
      return (
        (searchTerm === "" || residence.name.toLowerCase().includes(searchTerm.toLowerCase())) &&
        (countryFilter === "" || residence.country === countryFilter) &&
        (cityFilter === "" || residence.city === cityFilter) &&
        (typeFilter === "" || residence.type === typeFilter)
      );
    });
    setFilteredResidences(filtered);
  }, [searchTerm, countryFilter, cityFilter, typeFilter, residences]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">الإقامات</h1>
      <Link to='/CreateResidencePage' className='px-4 py-2 bg-green-600 text-gray-50 rounded-md mx-auto my-6'>
        إضافة إقامة
      </Link>

      {/* شريط البحث والفلاتر */}
      <div className="flex flex-wrap justify-between mb-6 mt-6">
        <input
          type="text"
          placeholder="البحث حسب اسم الإقامة"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        />
        <select
          value={countryFilter}
          onChange={(e) => setCountryFilter(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        >
          <option value="">فلترة حسب البلد</option>
          {countries.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
        <select
          value={cityFilter}
          onChange={(e) => setCityFilter(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        >
          <option value="">فلترة حسب المدينة</option>
          {cities.map((city) => (
            <option key={city} value={city}>
              {city}
            </option>
          ))}
        </select>
        <select
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        >
          <option value="">فلترة حسب النوع</option>
          <option value="Apartment">شقة</option>
          <option value="Villa">فيلا</option>
          <option value="House">منزل</option>
        </select>
      </div>

      {/* عرض الإقامات */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        {filteredResidences.length > 0 ? (
          filteredResidences.map((residence) => (
            <div
              key={residence.id}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <img src={residence.image} alt="الإقامة" className="w-full h-64 object-cover rounded-md mb-4" />
              <h2 className="text-2xl font-semibold text-gray-800">{residence.name}</h2>
              <p className="text-gray-600 mt-2">{residence.description}</p>
              <p className="text-gray-500 mt-2">المدينة: {residence.city}</p>
              <p className="text-gray-500">البلد: {residence.country}</p>
              <p className="text-gray-500">النوع: {residence.type}</p>
              <p className="text-xl font-bold text-gray-900 mt-4">نطاق السعر:دج{residence.price}</p>
              <Link
                to={`/residence/${residence.id}`}
                className="mt-4 text-green-600 hover:text-green-800"
              >
                عرض المزيد
              </Link>
            </div>
          ))
        ) : (
          <p className="col-span-full text-center text-lg text-gray-600">لم يتم العثور على أي إقامات.</p>
        )}
      </div>

      {/* قسم الخريطة */}
      <div className="w-full h-96">
        <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={mapCenter}
            zoom={mapZoom}
          >
            {filteredResidences.map((residence) => (
              <Marker
                key={residence.id}
                position={{ lat: residence.lat, lng: residence.lng }}
                title={residence.name}
              />
            ))}
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default ResidencePage;
